import * as statuses from "./SelectList/Status";
import { mapOwnStatusToApiStatus } from "./SelectList/PaymentsStatus";
import { requests } from "../../api/request";

export const getAppointment = async ({
     start,
     end,
     status,
     partners,
     paymentsStatus,
     markup,
     page
}) => {
    const appointmentUrl = `/appointments${buildUrlParams(
        start,
        end,
        status,
        partners,
        paymentsStatus,
        markup,
        page
    )}`;

    try {
        const responseAllData = await requests.get(appointmentUrl,{});

        if (responseAllData.data) {

            return { appointments: responseAllData.data };
        } else {
            throw new Error("No data found in the response.");
        }
    } catch (error) {
        if (error.request
            && error.request.status
            && error.request.status === 401
        ) {
            window.location.replace('/guest/login');
        }
        throw error;
    }
};

export const getCountByPartner = async ({
    start,
    end,
    status,
    partners,
    paymentsStatus,
    markup,
    page
}) => {
    const countAppointmentByPartnerUrl = `/appointments/count-by-partner${buildUrlParams(
        start,
        end,
        status,
        partners,
        paymentsStatus,
        markup,
        page
    )}`;

    try {
        const responseCountByPartner = await requests.get(countAppointmentByPartnerUrl,{});

        if (responseCountByPartner.data) {
            return { count: responseCountByPartner.data };
        } else {
            throw new Error("No data found in the response.");
        }
    } catch (error) {
        if (error.request
            && error.request.status
            && error.request.status === 401
        ) {
            window.location.replace('/guest/login');
        }
        throw error;
    }
}

const buildUrlParams = (
    start,
    end,
    status,
    partners,
    paymentsStatus,
    markup,
    page
) => {
    const UrlParamList = getUrlParamList(
        status,
        partners,
        markup,
        start,
        end,
        page,
        paymentsStatus
    );

    return getUrlParams(UrlParamList);
}

const getUrlParamList = (
    status,
    partners,
    markup,
    start,
    end,
    page,
    paymentsStatus
) => {
    let statusesSelected = status.map((status) => status.value);
    if (statusesSelected.length === 0) {
        statusesSelected = statuses.list().map((status) => status.value);
    }

    const partnersValues = partners.map((partner) => partner.value);

    const paymentsStatusesSelected = paymentsStatus.map(
        (status) => mapOwnStatusToApiStatus(status.value)
    );

    let markupSelected = markup.map((markup) => markup.value);

    return {
        start : start,
        end : end,
        status : statusesSelected,
        partners : partnersValues,
        paymentsStatus : paymentsStatusesSelected,
        markup: markupSelected,
        page: page,
    };
}

const getUrlParams = (paramsList) => {
    return `?start=${paramsList.start}
        &end=${paramsList.end}
        &status=${encodeURIComponent(JSON.stringify(paramsList.status))}
        &partners=${encodeURIComponent(JSON.stringify(paramsList.partners))}
        &payments_status=${encodeURIComponent(JSON.stringify(paramsList.paymentsStatus))}
        &markups=${encodeURIComponent(JSON.stringify(paramsList.markup))}
        &_page=${encodeURIComponent(JSON.stringify(paramsList.page))}`;
}

export const getPaymentSummary = async ()  => {
    const paymentSummary = await requests.get('/appointments/payment-summary?status=succeeded',{});
    return paymentSummary.data;
}

export const getAppointmentSummary = async ()  => {

    const appointmentSummary = await requests.get(
        `/appointments/summary`,
        {}
    );

    return appointmentSummary.data;
}

export const getFakeAppointment = (pageIndex) => {
    // fill all previous pages with fake data for arrived to number page wanted in react table
    return Array.from(
        { length: pageIndex * 10 },
        () => ({
            created_at: '',
            practitioner: {id: 0},
            start_at: '',
            status: 'CONFIRMED'
        })
    )
}


// WEBPACK FOOTER //
// ./src/views/Dashboardlive/CallFilter.js